<div ref:foreground class='foreground {{mode}}'>
	{{#each scenes as scene, index }}

		{{#if !inIosApp || !( hideInApp && mode === 'landscape' )}}
			<article id='{{index}}' ref:hi class='scene {{ index + 1 }} {{scene.class}} {{hideChart ? "no-chart": ""}}'>
				<div class='gia-scroller-block {{inIosApp ? "ios-scroller-block" : "non-ios"}}'>
					{{{(inIosApp && mode === 'landscape' && appHtml) || scene.html}}}
				</div>

				{{#if inIosApp }}
				<div class='ios-image-wrapper'>
				<img class='ios-st-louis' src='<@baseUrl@>/<@version@>/files/images/st-louis-ios-app-scene-{{index + 1}}.png' />
			</div>
				{{/if}}
			</article>
		{{/if}}
	{{/each}}
</div>

<style>

.ios-image-wrapper {
	padding-top: 15px;
	padding-bottom: 15px;
}

.ios-st-louis {
	width: 100%;

}

.ios-scroller-block {
	padding-bottom: 10px;
}


.scroller-headline {
	/*font-family: 'Guardian Text Sans Web';*/
}
	.foreground {
		position: relative;
		z-index: 1002;
	}

	article {
		position: relative;
		padding-bottom: 400px;
	}

	article:before,
	article:after {
		content: ' ';
		display: table;
	}

	article:after {
		clear: both;
	}

	.title {
		padding-bottom: 550px;
	}

	.ios-app article {
		padding-bottom: 0;
	}

	.ios-app .landscape article {
		margin-bottom: 1em;
	}

	.web .gia-scroller-block {
		font-size: 16px;

		position: relative;
		top: 0;

		box-sizing: border-box;
		/*width: calc(100% - 2em);*/
		max-width: 40em;
		margin: 0 auto;
		padding: .5em 2rem;

		color: #333;
		background-color: rgba(255, 255, 255, .8);
		border-top: 1px solid #eee;
		border-bottom: 1px solid #eee;
	}

	.ios-app .gia-scroller-block {
		color: inherit;
		background-color: inherit;
		margin: 0;
	}

	.ios-app .landscape .gia-scroller-block {
		position: relative;;
		top: 1em;
	}

	.ios-app .no-chart .gia-scroller-block {
		position: relative;
	}

	.ios-app .title .gia-scroller-block {
		/*position: absolute;*/
		/*right: auto;*/
		bottom: auto;
		margin: 0 0 2em 0;
	}

	.web .title .gia-scroller-block {
		width: 100%;
		max-width: 100%;
		margin: 0;
		padding: 2em 2rem;
		margin-top: 30px;
	}


	.title h2 {
		margin: 0;
		/*font-family: DS7;*/
		line-height: 1.2;
		/*text-transform: uppercase;*/
		font-weight: 900;
		font-size: 30px;
	}

	.gia-scroller-block p {
		margin: 0 auto;
		/*font-family: 'Guardian Text Sans Web';*/
	}

	/*.gia-scroller-block p {
		font-size: 16px;
		margin: 0 auto;
		line-height: 1.2;
		text-rendering: optimizeLegibility;
	}*/

	.title .gia-scroller-block p {
		/*font-family: DS7 !important;*/
		font-size: 20px;
		color: #767676;
		line-height: 1.2;
	}

	.gia-scroller-block h2 {
		font-size: 1.8em;
		font-weight: bold;
		max-width: 100%;
		margin-bottom: 5px;
		padding: 0;
	}

	.landscape article {
		padding: 0 50px 400px 66.666%;
	}

	article:last-child {
		/*padding-bottom: 80px;*/
		padding-bottom: 275px;
	}

	article:last-child .gia-scroller-block {
		padding-bottom: 40px;
		border-bottom: none;
	}

	.ios-app article:last-child {
		padding-bottom: 0;
	}

	.ios-app .landscape article {
		padding: 0;
	}

	/*.landscape .gia-scroller-block {
		background-color: transparent;
		border: none;
	}*/

	/*.landscape .gia-scroller-block */

	p {
		/*font-family: 'Guardian Text Sans Web';*/
	}

	.ios-app .landscape .gia-scroller-block {
		width: 33.333%;
		float: right;
		clear: both;
	}

	@keyframes bounce {
		0% {
			-webkit-transform:translateY(-20%);
			transform:translateY(-20%);
		}

		100% {
			-webkit-transform:translateY(20%);
			transform:translateY(20%);
		}
	}

	.title .gia-scroller-block .gia-continue-scrolling p {
		opacity: 0.7;
		margin: 2em 0;
		color: #c05303 !important;
	}

	.ios-app .gia-continue-scrolling {
		display: none;
	}

	.gia-continue-scrolling p {
		/*font-family: 'Guardian Text Sans Web';*/
		/*color: #4bc6df;*/
		font-weight: bold;
	}

	.gia-continue-scrolling span {
		display: inline-block;
		width: 2em;
		height: 2em;
		margin: 0 0.5em;
		background: url(<@baseUrl@>/<@version@>/files/icons/chevron.svg) 50% 50% no-repeat;
		background-size: 100% 100%;
		animation: 1s ease-in-out alternate infinite bounce;
		position: relative;
		top: 0.8em;
	}

	.ios-scroller-block:last-child {
		padding-bottom: 0px;
	}

	.ios-scroller-block article:last-child {
		/*padding-bottom: 80px;*/
		padding-bottom: 0px;
	}

</style>

<script>
import * as eases from 'eases-jsnext';

const inIosApp = typeof navigator === 'undefined' ? true : ( /(iPhone|iPod|iPad).*AppleWebKit(?!.*Version)/i.test( navigator.userAgent ) && /ios/.test( document.body.getAttribute( 'class' ) ) ) ||
/app-preview=true/.test( window.location.search );


export default {
	data () {
		return {
			inIosApp
		};
	},

	onrender () {
		if ( this.get( 'inIosApp' ) ) return;

	this.container = this.refs.foreground;

	const handleScroll = () => {
		// let i = this.sceneBlocks.length;
		const references = this.get('references');
		let i = 6;
		const { top, bottom } = references.backgroundRef.refs.fixTarget.getBoundingClientRect();
		// let max = top + ( bottom - top ) * 0.75;
		let max = top + ( bottom - top ) * 0.75;
		let bcr;

		while ( i-- ) {
			const sceneBlock = document.getElementById(i);
			// console.log(sceneBlock, 'SCENEBLOCK')
			const { top, bottom } = sceneBlock.getBoundingClientRect();
			// console.log(top,bottom)
			const height = bottom - top;
			// console.log( 'i:', i,  'top:', top, 'bottom:', bottom, 'max:', max )
			if ( top < max && bottom > max ) {
				this.set( {'sceneIndex': i} );
				// console.log(i, 'I')
				return;
			}
		}
	};

	const handleResize = () => {
		this.set({
			windowWidth: window.innerWidth,
			windowHeight: window.innerHeight
		});

		handleScroll();
	};

	setTimeout( () => {
		window.addEventListener( 'scroll', handleScroll, false );
		window.addEventListener( 'resize', handleResize, false );

		handleResize();
	});
}

};

</script>
